/*
 * The backend's error body (turaq-backend, all modules):
 *   { statusCode, message, error, code?, retryAfter?, feature?, short?, price?,
 *     balance?, refund?, limit?, listing_ids? }
 * One reader for it, so every screen asks the same questions the same way.
 */

export interface ApiErrorBody {
  statusCode?: number;
  message?: string | string[];
  error?: string;
  code?: string;
  retryAfter?: number;
  feature?: string;
  short?: number;
  price?: number;
  balance?: number;
  refund?: number;
  limit?: number;
  listing_ids?: number[];
}

export interface ApiErrorInfo extends ApiErrorBody {
  status: number | null;
  /** 404 without a `code`: the route isn't there (feature flag off) — use the old way. */
  missing: boolean;
}

export function apiError(e: unknown): ApiErrorInfo {
  const r = (e as { response?: { status?: number; data?: unknown } } | null)?.response;
  const body = (r?.data && typeof r.data === "object" ? r.data : {}) as ApiErrorBody;
  const status = typeof r?.status === "number" ? r.status : null;
  return { ...body, status, missing: status === 404 && !body.code };
}

/** «через N мин» for a `retryAfter` in seconds (at least 1 minute). */
export const retryMinutes = (retryAfter: number | undefined) => Math.max(1, Math.ceil((Number(retryAfter) || 60) / 60));

/** The server's message as one line (Nest validation sends an array). */
export const apiMessage = (e: ApiErrorBody) => (Array.isArray(e.message) ? e.message.join(", ") : e.message) || "";
